module.exports = __webpack_public_path__ + "static/media/SWSCRC6-25.2858cc51.mp3";